const API_URL = process.env.REACT_APP_BACKEND_URL;

// API helper for settings
export const settingsAPI = {
  update: async (data) => {
    const token = localStorage.getItem('access_token');
    try {
      const response = await fetch(`${API_URL}/api/settings`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      });
      return response.ok;
    } catch (e) {
      console.error('Failed to update settings:', e);
      return false;
    }
  },

  trackToolUsage: async (toolKey, toolName) => {
    const token = localStorage.getItem('access_token');
    try {
      await fetch(`${API_URL}/api/tools/track-usage`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ tool_key: toolKey, tool_name: toolName })
      });
    } catch (e) {
      console.debug('Failed to track tool usage:', e);
    }
  },

  fetchAccessStatus: async () => {
    const token = localStorage.getItem('access_token');
    if (!token) return null;

    try {
      const response = await fetch(`${API_URL}/api/access/status`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });

      if (response.ok) {
        return await response.json();
      }
    } catch (error) {
      console.debug('Failed to load access status:', error);
    }
    return null;
  }
};
